import React, { ChangeEventHandler } from 'react'
import SearchIcon from '@mui/icons-material/Search'
import { TextField, InputAdornment } from '@mui/material'

interface Props {
  onChange: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>
  placeholder?: string
  name: string
}

const SearchTextInput:ReactFC<Props> = ({
  onChange,
  name,
  placeholder
}) => {
  return (
    <TextField
      name={name}
      placeholder={placeholder ?? 'Buscar...'}
      onChange={onChange}
      InputProps={{
        startAdornment: (
          <InputAdornment position='start'>
            <SearchIcon/>
          </InputAdornment>
        )
      }}
    />
  )
}
export default SearchTextInput
